import { render, staticRenderFns } from "./WebForms.vue?vue&type=template&id=0852c292&scoped=true&"
import script from "./WebForms.vue?vue&type=script&lang=js&"
export * from "./WebForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852c292",
  null
  
)

export default component.exports